import React from 'react'

function ApprovedGoodsLoanLayer() {
  return (
    <div>ApprovedGoodsLoanLayer</div>
  )
}

export default ApprovedGoodsLoanLayer